import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("fcos_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const DIMENSION_META = {
  emotional_intelligence: { label: "Emotional Intelligence", color: "#EC4899", accent: "#EC4899" },
  leadership: { label: "Leadership", color: "#C9A961", accent: "#C9A961" },
  communication: { label: "Communication", color: "#0B1E36", accent: "#0B1E36" },
  belonging: { label: "Belonging", color: "#2C7A7B", accent: "#2C7A7B" },
  community_engagement: { label: "Community Engagement", color: "#8B5CF6", accent: "#8B5CF6" },
};
